import { dialogRegisterQuestionnaireState } from '@/features/dialogSlice'
import { raundUrl } from '@/lib/custom'
import { useCampaignSlug } from '@/lib/useCampaignSlug'
import { useFetchGet } from '@/lib/useFetch'
import { useRouter } from 'next/router'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

const PageView = () => {
  const router = useRouter()
  const dispatch = useDispatch()
  // FIXME: ここの型を適切なものに変更する
  const { getWithAuth: getQuestionnairesAnswerType } = useFetchGet<any>({})
  const { LOCAL_STORAGE_PERIOD_KEY, LOCAL_STORAGE_JWT_KEY, LOCAL_STORAGE_REGISTER_QUESTIONNAIRES_KEY, gen } =
    useCampaignSlug()

  const questionnaires = async () => {
    try {
      // 回答してるかどうか
      const authQuestionnairesFetch = await getQuestionnairesAnswerType(`${raundUrl.questionnairesAnswerType}/1`)
      const result = (await authQuestionnairesFetch) as any

      console.log(result)

      if (result.status === 404 || result.code === 'answered') {
        // 存在しないまたは回答済み
        localStorage.setItem(LOCAL_STORAGE_REGISTER_QUESTIONNAIRES_KEY, 'answered')
        dispatch(dialogRegisterQuestionnaireState(false))
        if (router.pathname.startsWith(gen('/auth'))) {
          location.href = gen('/')
        }

        return
      }

      if (result.code === 'unanswered') {
        dispatch(dialogRegisterQuestionnaireState(true))
      }
    } catch (error) {
      console.log(error)
    }
  }

  // JWTがない場合、ログインページへ遷移させる
  useEffect(() => {
    const Period = localStorage.getItem(LOCAL_STORAGE_PERIOD_KEY)
    const jwt = localStorage.getItem(LOCAL_STORAGE_JWT_KEY)

    if (router.pathname.startsWith('/[campaign]/auth')) return
    if (router.pathname.startsWith('/[campaign]/reservation')) return
    if (router.pathname.startsWith('/[campaign]/payment')) return

    if (!jwt) {
      if (Period) return
      if (router.pathname.startsWith('/[campaign]/qr')) return
      if (router.pathname.endsWith('/500')) return
      if (router.pathname.endsWith('/404')) return
      if (router.pathname === '/') {
        // ログインしていない && キャンペーンのパスでアクセスしていない場合、500を表示
        location.href = gen('/500')
        return
      }
      location.href = gen('/auth/signin')
    } else {
      if (localStorage.getItem(LOCAL_STORAGE_REGISTER_QUESTIONNAIRES_KEY)) return
      questionnaires()
    }
  }, [router.events, router])

  return <></>
}

export default PageView
